import { render, staticRenderFns } from "./answer_list.vue?vue&type=template&id=cdb4bb5e"
import script from "./answer_list.vue?vue&type=script&lang=js"
export * from "./answer_list.vue?vue&type=script&lang=js"
import style0 from "./answer_list.vue?vue&type=style&index=0&id=cdb4bb5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports